import { useCallback, useMemo } from "react"

import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useMapDispatchContext } from "@l2r-front/l2r-map"
import { useNetworksDispatchContext } from "@l2r-front/l2r-networks"
import { BottomSheetContent, Typography, useIsMobileDevice } from "@l2r-front/l2r-ui"
import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

import { RiskAreasIndicator } from "../RiskAreasIndicator"
import { RiskZonesGrades } from "../RiskZonesGrades"
import { RiskZonesTrafficInfo } from "../RiskZonesTrafficInfo"

import * as Styled from "./RiskZonesSidebar.styled"

export function RiskZonesSidebar() {

    const { t } = useTranslation(I18N_NAMESPACE)
    const { road } = useParams()
    const { setRoadSearched } = useNetworksDispatchContext()
    const { setMapPin } = useMapDispatchContext()
    const navigate = useNavigateWithSearchParams()
    const isMobile = useIsMobileDevice()


    const navigateBack = useCallback(() => {
        setRoadSearched(null)
        setMapPin()
        navigate("..")
    }, [navigate, setRoadSearched, setMapPin])


    const michelinLogoComponent = useMemo(() => {
        if (!road) {
            return <Styled.Partnership logo={<Styled.Logo src="assets/resources/michelin.png" />} />
        }
        return null
    }, [road])

    return (
        <BottomSheetContent
            id="riskzones-sidebar"
            onBack={road ? navigateBack : null}
            title={t(I18N_NAMESPACE, `containers.riskZonesSidebar.${road ? "roadTitle" : "title"}`)}
            titleBottomComponent={michelinLogoComponent}
        >
            <Styled.Container isMobile={isMobile}>
                <Styled.ContentWrapper>
                    {road && <Styled.RoadDetailInfo isMobile={isMobile} road={road} />}
                    <RiskZonesGrades />
                    <Typography variant="Desktop & Mobile/Heading/H2">{t(I18N_NAMESPACE, "containers.riskAreasIndicator.title")}</Typography>
                    <RiskAreasIndicator />
                    <RiskZonesTrafficInfo />
                </Styled.ContentWrapper>
            </Styled.Container>
        </BottomSheetContent>
    )
}